import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";

var ReplacementReserveData =
/*#__PURE__*/
function () {
  function ReplacementReserveData() {
    _classCallCheck(this, ReplacementReserveData);
  }

  _createClass(ReplacementReserveData, [{
    key: "GetReplacement_List",
    value: function () {
      var _GetReplacement_List = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(isAdmin, userId, projectId, statusId, year) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/GetReplacementList/".concat(isAdmin, "/").concat(userId, "/").concat(projectId, "/").concat(statusId, "/").concat(year)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function GetReplacement_List(_x, _x2, _x3, _x4, _x5) {
        return _GetReplacement_List.apply(this, arguments);
      }

      return GetReplacement_List;
    }()
  }, {
    key: "GetProperty_List",
    value: function () {
      var _GetProperty_List = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(isAdmin, userId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/GetPropertyList/".concat(isAdmin, "/").concat(userId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function GetProperty_List(_x6, _x7) {
        return _GetProperty_List.apply(this, arguments);
      }

      return GetProperty_List;
    }()
  }, {
    key: "GetRequest",
    value: function () {
      var _GetRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(requestId, projectId, isAdmin) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/GetRequest/".concat(requestId, "/").concat(projectId, "/").concat(isAdmin)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function GetRequest(_x8, _x9, _x10) {
        return _GetRequest.apply(this, arguments);
      }

      return GetRequest;
    }()
  }, {
    key: "GetLetterData",
    value: function () {
      var _GetLetterData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(requestId, userId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/GetLetterData/".concat(requestId, "/").concat(userId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function GetLetterData(_x11, _x12) {
        return _GetLetterData.apply(this, arguments);
      }

      return GetLetterData;
    }()
  }, {
    key: "AdminChangeStatus",
    value: function () {
      var _AdminChangeStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(ReplacementReserveRequestId, StatusId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("api/AdminChangeStatus/".concat(ReplacementReserveRequestId, "/").concat(StatusId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function AdminChangeStatus(_x13, _x14) {
        return _AdminChangeStatus.apply(this, arguments);
      }

      return AdminChangeStatus;
    }()
  }, {
    key: "ChangeStatus",
    value: function () {
      var _ChangeStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(statusID, requestId, userId, request, approvedAmounts) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.post("/api/ChangeStatus", {
                  statusID: statusID,
                  requestId: requestId,
                  userId: userId,
                  approvedAmounts: approvedAmounts,
                  request: request
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function ChangeStatus(_x15, _x16, _x17, _x18, _x19) {
        return _ChangeStatus.apply(this, arguments);
      }

      return ChangeStatus;
    }()
  }, {
    key: "CheckForDuplicates",
    value: function () {
      var _CheckForDuplicates = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(invoiceNum, invoiceDate, vendorId, index) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.post("/api/CheckForReplacementDuplicates", {
                  InvoiceNumber: invoiceNum,
                  InvoiceDate: invoiceDate,
                  VendorId: vendorId,
                  ReplacementReserveRequestItemId: index
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function CheckForDuplicates(_x20, _x21, _x22, _x23) {
        return _CheckForDuplicates.apply(this, arguments);
      }

      return CheckForDuplicates;
    }()
  }, {
    key: "UnSubmitRentIncrease",
    value: function () {
      var _UnSubmitRentIncrease = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(requestId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.post("api/ReplacementReserve/UnSubmit", requestId, {
                  headers: {
                    "Content-Type": "application/json"
                  }
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function UnSubmitRentIncrease(_x24) {
        return _UnSubmitRentIncrease.apply(this, arguments);
      }

      return UnSubmitRentIncrease;
    }()
  }, {
    key: "StartReview",
    value: function () {
      var _StartReview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(requestId) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.get("/api/ReplacementReserve/StartReview/".concat(requestId)));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function StartReview(_x25) {
        return _StartReview.apply(this, arguments);
      }

      return StartReview;
    }()
  }, {
    key: "SaveReview",
    value: function () {
      var _SaveReview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(requestId, userId, request, approvedAmounts) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", axios.post("/api/SaveReplacementReview", {
                  requestId: requestId,
                  userId: userId,
                  approvedAmounts: approvedAmounts,
                  request: request
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function SaveReview(_x26, _x27, _x28, _x29) {
        return _SaveReview.apply(this, arguments);
      }

      return SaveReview;
    }()
  }, {
    key: "SaveReplacement",
    value: function () {
      var _SaveReplacement = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(requestDescription, typeSelected, instructions, tableData, StatusId, requestId, projectId, itemDeleteIndexes, userId, submittedAsException, submitted, reSubmitted) {
        var request, items;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                request = {
                  ReplacementReserveRequestId: requestId,
                  ProjectId: projectId,
                  Description: requestDescription,
                  StatusId: StatusId,
                  Instructions: instructions,
                  SubmittedById: userId,
                  SubmittedAsException: submittedAsException,
                  Submitted: submitted,
                  ReSubmitted: reSubmitted
                };
                items = [];
                tableData.forEach(function (x) {
                  return items.push({
                    Age: x.age,
                    CheckNumber: x.checkNum,
                    DescriptionOfWork: x.description,
                    DuplicateInvoiceComment: x.comments,
                    InvoiceDate: x.invoiceDate,
                    InvoiceNumber: x.invoiceNum,
                    ReplacementReserveRequestItemId: x.itemId,
                    Location: x.location,
                    ClaimedAmount: x.money,
                    PayVendorDirectly: x.payDirectly,
                    NewVendor: x.newVendor,
                    VendorId: x.vendorId
                  });
                });
                return _context11.abrupt("return", axios.post("/api/SaveReplacementProgress", {
                  request: request,
                  items: items,
                  type: typeSelected,
                  itemDeleteIndexes: itemDeleteIndexes
                }));

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function SaveReplacement(_x30, _x31, _x32, _x33, _x34, _x35, _x36, _x37, _x38, _x39, _x40, _x41) {
        return _SaveReplacement.apply(this, arguments);
      }

      return SaveReplacement;
    }()
  }, {
    key: "UploadFile",
    value: function () {
      var _UploadFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(files, projectId, requestId, fileName, internalToMHDC) {
        var formData;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                formData = new FormData();
                files.forEach(function (file) {
                  formData.append("files[]", file);
                });
                formData.append("projectId", projectId);
                formData.append("requestId", requestId);
                formData.append("fileName", fileName);
                formData.append("internalToMHDC", internalToMHDC);
                return _context12.abrupt("return", axios.post("/api/ReplacementReserveFileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }));

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function UploadFile(_x42, _x43, _x44, _x45, _x46) {
        return _UploadFile.apply(this, arguments);
      }

      return UploadFile;
    }()
  }, {
    key: "GetLastApprovedRequest",
    value: function () {
      var _GetLastApprovedRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13(projectId) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", axios.get("/api/ReplacementReserve/GetLastApprovedRequest/".concat(projectId)));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function GetLastApprovedRequest(_x47) {
        return _GetLastApprovedRequest.apply(this, arguments);
      }

      return GetLastApprovedRequest;
    }()
  }, {
    key: "CopyW9s",
    value: function () {
      var _CopyW9s = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14(requestId) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", axios.post("/api/ReplacementReserve/CopyW9s/".concat(requestId)));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function CopyW9s(_x48) {
        return _CopyW9s.apply(this, arguments);
      }

      return CopyW9s;
    }()
  }]);

  return ReplacementReserveData;
}();

export default new ReplacementReserveData();